import React, { useRef, useState, useEffect, memo } from "react";
import { View, StyleSheet, TouchableNativeFeedback } from "react-native";
import Image from "@components/common/Image";
import Text from "@components/AppText";
// import OfferSmall from "@assets/svg/OfferSmall";
import Discount from "@assets/svg/Discount";
import { normalize, width } from "./metrics";
import DiscountStrip from "./DiscountStrip";
import NotifyButton from "./NotifyButton";
import SuccessSmall from "@assets/svg/SuccessSmall";
// import ImageAutoScale from "@components/ImageAutoScale";
import { useSelector, useDispatch } from "react-redux";
import { useNavigation } from "@react-navigation/native";
// import { actions as productActions } from "@redux/reducers/products.reducer";
import { notifyForOOS } from "@services/api";
import {
  CMS_ENTITY_TYPE,
  ORDER_FLOW_EVENTS,
} from "../../constants/analyticsEventsCT";
import { actions as productActions } from "@reducers/productReducer";

const Product = memo(
  ({
    data,
    index,
    defaultShare,
    sharingTemplate,
    routeName = "",
    trackEvent = () => {},
    skuListData = {},
    horizontal = false,
    navigateMethod = "navigate",
    disabled,
  }) => {
    const {
      discount,
      discount_type,
      short_name_hi,
      product_image,
      price_tl_single_buy,
      price_per_unit,
      mrp,
      grammage,
      custom_text,
      product_status,
      slug,
      sku_id,
      product_name_hi,
      images = [],
    } = data;

    const [notified, setNotified] = useState(false);
    const dispatch = useDispatch();
    const navigation = useNavigation();
    const notifyOOS = () => {
      setNotified(true);
      notifyForOOS({ sku_id })
        .then(() => {
          dispatch(productActions.requestForOosSkus());
        })
        .catch((e) => {
          console.log(e);
        });
    };

    const oosProducts =
      useSelector((state) => state.products.oosProducts) || [];

    const isOutOfStockNotified =
      oosProducts.findIndex((p) => p.sku_id === sku_id) !== -1;

    useEffect(() => {
      setNotified(isOutOfStockNotified);
    }, [isOutOfStockNotified, oosProducts]);

    return (
      <TouchableNativeFeedback
        disabled={disabled}
        onPress={() => {
          navigation[navigateMethod]("ProductDetails", {
            slug: slug,
            fromScreen: routeName,
            cmsData: skuListData,
          });
          trackEvent(CMS_ENTITY_TYPE.PRODUCT, {
            ...skuListData,
            sku_id,
            product_price: price_tl_single_buy,
            product_name: product_name_hi,
            position: index,
          });
        }}
      >
        <View
          style={{
            borderColor: "#EEEEEE",
            borderWidth: 1,
            width: horizontal ? width * 0.6 : width * 0.5,
            position: "relative",
            paddingBottom: normalize(18),
            paddingTop: horizontal ? normalize(15) : normalize(10),
            marginRight: horizontal ? normalize(10) : 0,
          }}
        >
          <Image
            resizeMode={Image.resizeMode.contain}
            style={{
              alignSelf: "center",
              width: normalize(100),
              height: normalize(100),
              opacity: 0.2,
            }}
            source={
              product_image
                ? {
                    uri: product_image,
                  }
                : require("@assets/images/defaultImage.webp")
            }
            // source={require("/Users/sameer/Desktop/cm-customer-app/@assets/images/blank.jpeg")}
          />
          <View
            style={{
              paddingHorizontal: normalize(10),
              marginTop: normalize(10),
            }}
          >
            <Text numberOfLines={1} ellipsizeMode="tail">
              {short_name_hi}
            </Text>
          </View>
          <View
            style={{
              marginTop: normalize(5),
              paddingHorizontal: normalize(10),
            }}
          >
            <Text style={{ color: "#FF2E00", fontSize: normalize(16) }}>
              यह प्रोडक्ट स्टॉक में नहीं है
            </Text>
          </View>
          <View style={{ marginTop: "auto" }}>
            {!notified ? (
              <NotifyButton
                width="89%"
                style={{ alignSelf: "center" }}
                onPress={notifyOOS}
              />
            ) : (
              <View
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.05)",
                  borderRadius: 6,
                  paddingHorizontal: 5,
                  flexDirection: "row",
                  alignItems: "center",

                  alignSelf: "center",
                  height: normalize(30),
                }}
              >
                <SuccessSmall />
                <Text
                  style={{
                    color: "rgba(0, 0, 0, 0.56)",
                    fontSize: normalize(14),
                    marginLeft: normalize(2),
                  }}
                >
                  आपको सूचित किया जायेगा
                </Text>
              </View>
            )}
          </View>
        </View>
      </TouchableNativeFeedback>
    );
  },
);

export default Product;

const styles = StyleSheet.create({
  mrp: {
    fontSize: normalize(12),
    lineHeight: normalize(16),
    marginLeft: normalize(7),
    textDecorationLine: "line-through",
  },
});
